import { Routes } from '@angular/router';
import { Mainlayout } from './Layouts/mainlayout/mainlayout';
import { NgModule } from '@angular/core';
import { authGuard } from './core/guards/auth.guard';
import { sectionGuard } from './core/guards/section.guard';

@NgModule({
    imports: [Mainlayout],
    exports: [Mainlayout]
})
export class AppRoutes {

}

export const routes: Routes = [
    {
        path: 'login',
        pathMatch: 'full',
        loadComponent: () => import('./Pages/login/login').then(m => m.Login)

    },
    {
        path: '',
        component: Mainlayout,
        canActivate: [authGuard],
        children: [
            {
                path: '',
                redirectTo: '/dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                loadComponent: () => import('./Pages/home/home').then(m => m.Home)
            },
            {
                path: 'livemap',
                loadComponent: () => import('./Pages/modulelivemap/livemap/livemap').then(m => m.Livemap)
            },
            {
                path: 'trips',
                loadComponent: () => import('./Pages/moduletrips/trips/trips').then(m => m.Trips)
            },
            {
                path: 'trips/createtrip',
                loadComponent: () => import('./Pages/moduletrips/createtrip/createtrip').then(m => m.Createtrip)
            },
            {
                path: 'trips/edittrip/:id',
                loadComponent: () => import('./Pages/moduletrips/edittripbase/edittripbase').then(m => m.Edittripbase)
            },
            {
                path: 'trips/detailstrip/:id',
                loadComponent: () => import('./Pages/moduletrips/detailstripbase/detailstripbase').then(m => m.Detailstripbase)
            },
            {
                path: 'drivers',
                canActivate: [sectionGuard],
                data: { section: 'workforce' },
                loadComponent: () => import('./Pages/moduledrivers/drivers/drivers').then(m => m.Drivers)
            },
            {
                path: 'drivers/editdriver/:id',
                canActivate: [sectionGuard],
                data: { section: 'workforce' },
                loadComponent: () => import('./Pages/moduledrivers/editdriver/editdriver').then(m => m.Editdriver)
            },
            {
                path: 'drivers/detailsdriver/:id',
                canActivate: [sectionGuard],
                data: { section: 'workforce' },
                loadComponent: () => import('./Pages/moduledrivers/detailsdriver/detailsdriver').then(m => m.Detailsdriver)
            },
            {
                path: 'vehicles',
                canActivate: [sectionGuard],
                data: { section: 'logistics' },
                loadComponent: () => import('./Pages/modulevehicles/vehicles/vehicles').then(m => m.Vehicles)
            },
            {
                path: 'vehicles/createvehicle',
                canActivate: [sectionGuard],
                data: { section: 'logistics' },
                loadComponent: () => import('./Pages/modulevehicles/createvehicle/createvehicle').then(m => m.Createvehicle)
            },
            {
                path: 'vehicles/editvehicle/:id',
                canActivate: [sectionGuard],
                data: { section: 'logistics' },
                loadComponent: () => import('./Pages/modulevehicles/editvehicle/editvehicle').then(m => m.Editvehicle)
            },
            {
                path: 'vehicles/detailsvehicle/:id',
                canActivate: [sectionGuard],
                data: { section: 'logistics' },
                loadComponent: () => import('./Pages/modulevehicles/detailsvehicle/detailsvehicle').then(m => m.Detailsvehicle)
            },
            {
                path: 'contracts',
                canActivate: [sectionGuard],
                data: { section: 'clients' },
                loadComponent: () => import('./Pages/modulecontracts/contracts/contracts').then(m => m.Contracts)
            },
            {
                path: 'contracts/createcontract',
                canActivate: [sectionGuard],
                data: { section: 'clients' },
                loadComponent: () => import('./Pages/modulecontracts/createcontract/createcontract').then(m => m.Createcontract)
            },
            {
                path: 'contracts/editcontract/:id',
                canActivate: [sectionGuard],
                data: { section: 'clients' },
                loadComponent: () => import('./Pages/modulecontracts/editcontract/editcontract').then(m => m.Editcontract)
            },
            {
                path: 'contracts/detailscontract/:id',
                canActivate: [sectionGuard],
                data: { section: 'clients' },
                loadComponent: () => import('./Pages/modulecontracts/detailscontract/detailscontract').then(m => m.Detailscontract)
            },
            {
                path: 'contracts/detailscontract/:id/services',
                canActivate: [sectionGuard],
                data: { section: 'clients' },
                loadComponent: () => import('./Pages/modulecontracts/detailscontract/services-list/services-list').then(m => m.ServicesList)
            },
            {
                path: 'locations',
                canActivate: [sectionGuard],
                data: { section: 'logistics' },
                loadComponent: () => import('./Pages/modulelocations/locations/locations').then(m => m.Locations)
            },
            {
                path: 'locations/createlocation',
                canActivate: [sectionGuard],
                data: { section: 'logistics' },
                loadComponent: () => import('./Pages/modulelocations/createlocation/createlocation').then(m => m.Createlocation)
            },
            {
                path: 'locations/editlocation/:id',
                canActivate: [sectionGuard],
                data: { section: 'logistics' },
                loadComponent: () => import('./Pages/modulelocations/editlocation/editlocation').then(m => m.Editlocation)
            },
            {
                path: 'locations/detailslocation/:id',
                canActivate: [sectionGuard],
                data: { section: 'logistics' },
                loadComponent: () => import('./Pages/modulelocations/detailslocation/detailslocation').then(m => m.Detailslocation)
            },
            {
                path: 'users',
                canActivate: [sectionGuard],
                data: { section: 'clients' },
                loadComponent: () => import('./Pages/moduleusers/users/users').then(m => m.Users)
            },
            {
                path: 'users/createuser',
                canActivate: [sectionGuard],
                data: { section: 'clients' },
                loadComponent: () => import('./Pages/moduleusers/createuser/createuser').then(m => m.Createuser)
            },
            {
                path: 'users/edituser/:id',
                canActivate: [sectionGuard],
                data: { section: 'clients' },
                loadComponent: () => import('./Pages/moduleusers/edituser/edituser').then(m => m.Edituser)
            },
            {
                path: 'users/detailsuser/:id',
                canActivate: [sectionGuard],
                data: { section: 'clients' },
                loadComponent: () => import('./Pages/moduleusers/detailsuser/detailsuser').then(m => m.Detailsuser)
            },
            {
                path: 'managers',
                canActivate: [sectionGuard],
                data: { section: 'workforce' },
                loadComponent: () => import('./Pages/modulemanagers/managers/managers').then(m => m.Managers)
            },
            {
                path: 'managers/createmanager',
                canActivate: [sectionGuard],
                data: { section: 'workforce' },
                loadComponent: () => import('./Pages/modulemanagers/createmanager/createmanager').then(m => m.Createmanager)
            },
            {
                path: 'managers/editmanager/:id',
                canActivate: [sectionGuard],
                data: { section: 'workforce' },
                loadComponent: () => import('./Pages/modulemanagers/editmanager/editmanager').then(m => m.Editmanager)
            },
            {
                path: 'managers/detailsmanager/:id',
                canActivate: [sectionGuard],
                data: { section: 'workforce' },
                loadComponent: () => import('./Pages/modulemanagers/detailsmanager/detailsmanager').then(m => m.Detailsmanager)
            },
            {
                path: 'settings',
                loadComponent: () => import('./Pages/settings/settings').then(m => m.Settings)
            },
            {
                path: 'reports/trips',
                loadComponent: () => import('./Pages/modulereports/tripreport/tripreport').then(m => m.Tripreport)
            },
            {
                path: 'reports/custom',
                loadComponent: () => import('./Pages/modulereports/customreport/customreport').then(m => m.Customreport)
            },
            {
                path: 'reports/drivers',
                canActivate: [sectionGuard],
                data: { section: 'driverReports' },
                loadComponent: () => import('./Pages/modulereports/driverreport/driverreport').then(m => m.Driverreport)
            },
            {
                path: 'reports/audit',
                canActivate: [sectionGuard],
                data: { section: 'auditReports' },
                loadComponent: () => import('./Pages/modulereports/auditreport/auditreport').then(m => m.Auditreport)
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];